// convert/compress invalid svg https://jakearchibald.github.io/svgomg/
import { ReactComponent as Facebook } from "../../images/Facebook_Logo.svg";
import { ReactComponent as Google } from "../../images/Google_Logo.svg";
import { ReactComponent as HolidayCheck } from "../../images/HolidayCheck_Logo.svg";
import { ReactComponent as Tripadvisor } from "../../images/TripAdvisor_Logo.svg";
import { ReactComponent as Trustpilot } from "../../images/Trustpilot_Logo.svg";
import { ReactComponent as Website } from "../../images/Website_Logo.svg";

const Icon = ({ name }) => {
  switch (name) {
    case "facebook":
      return <Facebook />;

    case "google":
      return <Google />;

    case "holidaycheck":
      return <HolidayCheck />;

    case "tripadvisor":
      return <Tripadvisor />

    case "trustpilot":
      return <Trustpilot />

    case "custom":
      return <Website />

    default:
      return <div>Icon not found {name}</div>;
  }
};

const Platform = ({ name, url }) => {
  return (
      <div className='tw1-p-2'>
        <a
            className='tw1-bg-[#f5f5f8] tw1-py-7 tw1-px-[18px] tw1-flex tw1-items-center tw1-justify-center tw1-h-[96px]'
            href={url}
            target='_blank'
            rel='noreferrer noopener'
        >
          <Icon name={name} />
        </a>
      </div>
  );
};

const Platforms = ({ platforms }) => {
  if (!platforms || platforms.length === 0) return null;

  // Detect the case where there is ONLY custom
  const onlyCustom = platforms.length === 1 && platforms[0].name === 'custom';

  if (onlyCustom) {
    const { url } = platforms[0];

    // Extract clean domain
    const domain = url
      .replace(/^https?:\/\//, "")   // remove http/https
      .replace(/^www\./, "")         // remove www.
      .replace(/\/$/, "");           // remove trailing slash

    return (
      <div className="tw1-text-center tw1-p-4">
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="tw1-text-blue-600 tw1-underline tw1-text-lg"
        >
          {domain}
        </a>
      </div>
    );
  }

  return (
      <div className='tw1-flex tw1-items-center tw1-flex-wrap tw1-justify-center'>
        {platforms.map(({ name, url }) => (
          <Platform name={name} key={name} url={url} />
        ))}
      </div>
  );
};

export default Platforms;
